/**
 * 网络请求：Axios
 */

import axios from "axios";
// import qs from "query-string";
import PopupToast from "@/pages/Public/PopupToast/PopupToast.js";

import md5 from "js-md5";

// 错误信息的响应方法
const errorHandle = (status,other) => {
    switch(status){
        case 400:
            // 请求头和服务器的限制
            console.log(" 服务器不理解请求的语法");
            break;
        case 401:
            // token验证失败，用户身份验证失败
            console.log("（未授权） 请求要求身份验证");
            break;
        case 403:
            // 用户身份过期了，服务器请求限制
            console.log("（禁止） 服务器拒绝请求");
            break;
        case 404:
            // 网络请求地址错误
            console.log("（未找到） 服务器找不到请求的网页。");
            break;
        default:
            console.log(other);
            break;
    }
}


// 创建axios对象
const instance = axios.create({
    timeout:60000,  // 请求超时
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        AppProject: "TomatoPlan",
        AppPlatform: "Web",
        AppVersion: "1.0.0",
        AppEnvironment: "production",
        // AppEnvironment: "test",
        ApiVersion: "1.0",
        DeviceId: "WebDeviceId",
        AppChannel: "Web",
        DeviceChannel: "",
        PushToken: "",
        AppLanguage: "Chinese",
    }
})


// 创建请求拦截和响应拦截操作
instance.interceptors.request.use(config =>{
        // 请求头加密参数
        const timeStamp = parseInt(new Date().getTime() / 1000).toString();
        const Grape = md5(timeStamp + "^tkn$2&F#y").toString();
        config.headers.timeStamp = timeStamp;
        config.headers.Grape = Grape;

        // 配置
        // if(config.method === 'post'){
        //     config.data = qs.stringify(config.data);
        // }
        const Jwt = localStorage.getItem("jwt");
        if(Jwt){
            config.headers.Jwt = Jwt;
        }
        return config;
    },
    error => Promise.reject(error)
)

// review自己的代码，也要不断的review的情感世界

instance.interceptors.response.use(
    // 成功
    /**
     * 成功和失败的判断：
     *  1.请求成功和请求失败
     *  2.请求成功：结果的成功和结果的失败
     */
    response => response.status === 200 ? Promise.resolve(response) : Promise.reject(response),
    // 我们自己封装的，所以为了代码的清晰可读性，我们需要增Promise
    // response => response,
    error => {
        const { response } = error; // ES6的解构赋值
        /**
         * response包含的信息：
         *  status
         *  data
         */
        PopupToast("网络异常，请求中断");
        if(response){
            // 给出开发者具体的错误信息
            errorHandle(response.status,response.data);
            return Promise.reject(response);

        }else{
            console.log("请求中断或者断网了");
        }
    }
)

export default instance;